export const NO_MORE_ORDERS_THRESHOLD = parseInt(
  process.env.REACT_APP_ORDERS_THRESHOLD_IN_TONS ?? "22"
);

export const IRM_CUSTOMER_SERVICE_PHONE_NUMBER = "1-800-453-8608";

export const getDateAtMidnight = (date = new Date()) => {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()); // We need today's date only, not the time
};
